import { render, staticRenderFns } from "./ChatAudioPlayer.vue?vue&type=template&id=772259d8&"
import script from "./ChatAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./ChatAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ChatAudioPlayer.vue?vue&type=style&index=0&id=772259d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports